import { UIHeading4, UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import * as style from './style.css';

interface IMapBalloonProps {
  id: string;
  title: string;
  distance: string;
  icon: React.ReactNode;
}

export const MapBalloon: React.FC<IMapBalloonProps> = ({ id, title, distance, icon }) => {
  return (
    <div className={style['wrapper']}>
      <div className={style['icon']}>{icon}</div>

      <div>
        <UIHeading4>{title}</UIHeading4>
        <UIText2>{distance}</UIText2>

        <div className={style['route-button']}>
          <UIText2 id={id} color="text-main-default">
            Построить маршрут
          </UIText2>
        </div>
      </div>
    </div>
  );
};
